/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderNumber: NonNullable<unknown> }} Orders_Cancel_Estes_Pickup_Description_OneInputs */

const en_orders_cancel_estes_pickup_description_one = /** @type {(inputs: Orders_Cancel_Estes_Pickup_Description_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancel pickup for order ${i?.orderNumber}?`)
};

const es_orders_cancel_estes_pickup_description_one = /** @type {(inputs: Orders_Cancel_Estes_Pickup_Description_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancelar recoleccion del pedido ${i?.orderNumber}?`)
};

/**
* | output |
* | --- |
* | "Cancel pickup for order {orderNumber}?" |
*
* @param {Orders_Cancel_Estes_Pickup_Description_OneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_estes_pickup_description_one = /** @type {((inputs: Orders_Cancel_Estes_Pickup_Description_OneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Estes_Pickup_Description_OneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_estes_pickup_description_one(inputs)
	return es_orders_cancel_estes_pickup_description_one(inputs)
});